<div class="col-md-12 float-left customersearch-forms login-forms p-0 customer-home-forms ">
  <form [formGroup]="quoteSearchForm" (ngSubmit)="submitForm()">
    <div class="form-group col-lg-6 pl-0 multi-select-styles">
      @if (!hasContext) {
        <ng-select [items]="customersDataList$ | async" [clearSearchOnAdd]="true"
          [closeOnSelect]="false" labelForId="state" [multiple]="true"  [placeholder]="'quoteSearchForm.label.accountNumber' | cxTranslate"
          clearAllText="Clear" formControlName="accountNumber" [bindLabel]="'Text'" [virtualScroll]="true">
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <div class="row">
              <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}"/>
              {{item['Text']}}
            </div>
          </ng-template>
          <ng-template ng-multi-label-tmp let-items="items">
            @for (item of items | slice:0:1; track item) {
              <div class="ng-value">
                {{item['Text']}}
              </div>
            }
            @if (items.length > 1) {
              <div class="ng-value">
                <span class="ng-value-label">{{items.length - 1}} more...</span>
              </div>
            }
          </ng-template>
        </ng-select>
      }
      @if (hasContext) {
        <input
          type="text"
          class="form-control w-100"
          [placeholder]="'quoteSearchForm.label.accountNumber' | cxTranslate"
          formControlName="accountNumber"
          />
      }
      <span class="highlight"></span>
      <label class="text-muted">{{ 'quoteSearchForm.label.accountNumber' | cxTranslate }}</label>
    </div>

    <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0">
      <input
        type="text"
        class="form-control w-100"
        placeholder="{{ 'quoteSearchForm.placeholder.suggestedQuote' | cxTranslate }}"
        formControlName="quoteNumber"
        />
        <span class="highlight"></span>
        <label class="text-muted">{{ 'quoteSearchForm.label.quoteNo' | cxTranslate }}</label>
      </div>

      <!-- <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0">
      <input
        type="text"
        class="form-control w-100"
        placeholder="{{ 'quoteSearchForm.label.accountNumber' | cxTranslate }}"
        formControlName="accountNumber"
        />
        <span class="highlight"></span>
        <label class="text-muted">{{ 'quoteSearchForm.label.accountNumber' | cxTranslate }} </label>
      </div>

      <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0">
        <input
          type="text"
          class="form-control w-100"
          placeholder="{{ 'quoteSearchForm.label.accountName' | cxTranslate }}"
          formControlName="accountName"
          />
          <span class="highlight"></span>
          <label class="text-muted">{{ 'quoteSearchForm.label.accountName' | cxTranslate }}</label>
        </div> -->

        <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0 multi-select-styles">
          <ng-select  [items]="validity$ | async" [clearSearchOnAdd]="true"
            [closeOnSelect]="false" labelForId="state" [multiple]="true"  [placeholder]="'orderReturnsSearchForm.placeholder.validity' | cxTranslate"
            clearAllText="Clear" formControlName="validity" [bindLabel]="'Text'" [ngModel]="pValidity">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div class="row">
                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"    [ngModelOptions]="{standalone: true}"/>
                {{item['Text']}}
              </div>
            </ng-template>
            <ng-template ng-multi-label-tmp let-items="items">
              @for (item of items | slice:0:1; track item) {
                <div class="ng-value">
                  {{item['Text']}}
                </div>
              }
              @if (items.length > 1) {
                <div class="ng-value">
                  <span class="ng-value-label">{{items.length - 1}} more...</span>
                </div>
              }
            </ng-template>
          </ng-select>

          <span class="highlight"></span>
          <label class="text-muted">{{ 'orderReturnsSearchForm.label.validity' | cxTranslate }}</label>
        </div>
        <!-- <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0" *ngIf="validity$ | async as items">
        <ng-select class="mb-1" formControlName="validity" [items]="validity$ | async"
          [placeholder]="'orderReturnsSearchForm.placeholder.validity' | cxTranslate" [searchable]="false" [clearable]="false" bindLabel="Text" bindValue="Key">
        </ng-select>

        <span class="highlight"></span>
        <label class="text-muted">{{ 'orderReturnsSearchForm.label.validity' | cxTranslate }}</label>
      </div> -->

      <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0">
        <input
          type="text"
          class="form-control w-100"
          placeholder="{{ 'quoteSearchForm.label.customerPO' | cxTranslate }}"
          formControlName="purchaseOrderNumber"
          />
          <span class="highlight"></span>
          <label class="text-muted">{{ 'quoteSearchForm.label.customerPO' | cxTranslate }} </label>
        </div>

        <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0 multi-select-styles">
          <ng-select  [items]="status$ | async" [clearSearchOnAdd]="true"
            [closeOnSelect]="false" labelForId="state" [multiple]="true" placeholder="{{ 'quoteCommon.label.status' | cxTranslate }}"
            clearAllText="Clear" formControlName="status" [bindLabel]="'Text'" [ngModel]="pStatus">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div class="row">
                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"    [ngModelOptions]="{standalone: true}"/>
                {{item['Text']}}
              </div>
            </ng-template>
            <ng-template ng-multi-label-tmp let-items="items">
              @for (item of items | slice:0:1; track item) {
                <div class="ng-value">
                  {{item['Text']}}
                </div>
              }
              @if (items.length > 1) {
                <div class="ng-value">
                  <span class="ng-value-label">{{items.length - 1}} more...</span>
                </div>
              }
            </ng-template>
          </ng-select>

          <span class="highlight"></span>
          <label class="text-muted">{{ 'quoteCommon.label.status' | cxTranslate }}</label>
        </div>
        <!-- <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0">
        <ng-select
          [items]="status$ | async"
          formControlName="status"
          bindLabel="Text"
          bindValue="Key"
          placeholder="{{ 'quoteCommon.label.status' | cxTranslate }}"
          [searchable]="false"
          [clearable]="false"
          >
        </ng-select>
        <span class="highlight"></span>
        <label class="text-muted">{{ 'quoteCommon.label.status' | cxTranslate }}</label>
      </div> -->

      <!-- <div class="col-lg-12 p-0 float-left"> -->
      <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0">
        <input
          type="text"
          class="form-control w-100 dateControls"
          placeholder="{{ 'quoteSearchForm.label.productNumber' | cxTranslate }}"
          formControlName="productCode"
          type="email"
          />
          <span class="highlight"></span>
          <label class="text-muted">{{ 'quoteSearchForm.label.productNumber' | cxTranslate }}</label>
        </div>

        <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0">
          <input type="text" class="form-control w-100"
            [placeholder]="'orderHistorySearchForm.label.productName' | cxTranslate" formControlName="productName" />
            <span class="highlight"></span>
            <label class="text-muted">{{ 'orderHistorySearchForm.label.productName' | cxTranslate }}</label>
          </div>

          @if (brandSalesShipToList$ | async; as items) {
            <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0 multi-select-styles">
              <label for="state">City</label>
              <ng-select  [items]="items.brand" [clearSearchOnAdd]="true"
                [closeOnSelect]="false" labelForId="state" [multiple]="true" placeholder="Brand"
                clearAllText="Clear" formControlName="brandName" [bindLabel]="'name'" [(ngModel)]="pBrandName">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div class="row">
                    <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"    [ngModelOptions]="{standalone: true}"/>
                    {{item['name']}}
                  </div>
                </ng-template>
                <ng-template ng-multi-label-tmp let-items="items">
                  @for (item of items | slice:0:1; track item) {
                    <div class="ng-value">
                      {{item['name']}}
                    </div>
                  }
                  @if (items.length > 1) {
                    <div class="ng-value">
                      <span class="ng-value-label">{{items.length - 1}} more...</span>
                    </div>
                  }
                </ng-template>
              </ng-select>
              <span class="highlight"></span>
              <label class="text-muted">{{ 'orderReturnsSearchForm.label.brand' | cxTranslate }}</label>
            </div>
          }

          @if (brandSalesShipToList$ | async; as items) {
            <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0 multi-select-styles">
              <ng-select  [items]="items.salesOffice" [clearSearchOnAdd]="true"
                [closeOnSelect]="false" labelForId="state" [multiple]="true" [placeholder]="'orderHistorySearchForm.label.salesOffice' | cxTranslate"
                clearAllText="Clear" formControlName="salesOffice" [bindLabel]="'name'" [ngModel]="pSalesOffice">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div class="row">
                    <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"    [ngModelOptions]="{standalone: true}"/>
                    {{item['name']}}
                  </div>
                </ng-template>
                <ng-template ng-multi-label-tmp let-items="items">
                  @for (item of items | slice:0:1; track item) {
                    <div class="ng-value">
                      {{item['name']}}
                    </div>
                  }
                  @if (items.length > 1) {
                    <div class="ng-value">
                      <span class="ng-value-label">{{items.length - 1}} more...</span>
                    </div>
                  }
                </ng-template>
              </ng-select>
              <span class="highlight"></span>
              <label class="text-muted">{{ 'orderHistorySearchForm.label.salesOffice' | cxTranslate }}</label>
            </div>
          }

          @if (brandSalesShipToList$ | async; as items) {
            <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0 multi-select-styles">
              <ng-select  [items]="items.salesGroup" [clearSearchOnAdd]="true"
                [closeOnSelect]="false" labelForId="state" [multiple]="true" [placeholder]="'orderHistorySearchForm.label.salesGroup' | cxTranslate"
                clearAllText="Clear" formControlName="salesGroup" [bindLabel]="'name'" [ngModel]="pSalesGroup">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div class="row">
                    <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"    [ngModelOptions]="{standalone: true}"/>
                    {{item['name']}}
                  </div>
                </ng-template>
                <ng-template ng-multi-label-tmp let-items="items">
                  @for (item of items | slice:0:1; track item) {
                    <div class="ng-value">
                      {{item['name']}}
                    </div>
                  }
                  @if (items.length > 1) {
                    <div class="ng-value">
                      <span class="ng-value-label">{{items.length - 1}} more...</span>
                    </div>
                  }
                </ng-template>
              </ng-select>
              <span class="highlight"></span>
              <label class="text-muted">{{ 'orderHistorySearchForm.label.salesGroup' | cxTranslate }}</label>
            </div>
          }

          <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-2 p-res-0 valid-to">
            <div class="input-group">
              <input class="form-control w-100 mb-0 dateControls" [placeholder]="'invoiceSearchForm.label.from' | cxTranslate"
                name="fromDate" ngbDatepicker #fromDate="ngbDatepicker" formControlName="_startDate" [readonly]="true"
                [maxDate]="maxStartDate()" (dateSelect)="onDateChange($event, 'fDate')" />
                <span class="highlight"></span>
                <label class="text-muted">{{ 'invoiceSearchForm.label.from' | cxTranslate }}</label>
                <div class="input-group-append">
                  <button class="btn btn calendar p-0 h-auto w-auto" container="body" (click)="fromDate.toggle()"
                    type="button">
                    <i class="far fa-calendar-alt color-font header-icon-color"></i>
                  </button>
                </div>
              </div>
              @if (quoteSearchForm.controls['_startDate'].errors; as errors) {
                @if (errors.required) {
                  <div class="fromDate">
                    Please select from date
                  </div>
                }
              }
            </div>

            <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 p-res-0 valid-to">
              <div class="input-group">
                <input class="form-control w-100 mb-0 dateControls" [placeholder]="'invoiceSearchForm.label.to' | cxTranslate" name="endDate"
                  ngbDatepicker #endDate="ngbDatepicker" formControlName="_endDate" [readonly]="true"
                  [maxDate]="maxEndDate()" (dateSelect)="onDateChange($event)" />
                  <span class="highlight"></span>
                  <label class="text-muted">{{ 'invoiceSearchForm.label.to' | cxTranslate }}</label>
                  <div class="input-group-append d-inline-block">
                    <button class="btn btn calendar p-0 h-auto w-auto" container="body" (click)="endDate.toggle()"
                      type="button">
                      <i class="far fa-calendar-alt color-font header-icon-color"></i>
                    </button>
                  </div>
                </div>
                @if (quoteSearchForm.controls['_endDate'].errors) {
                  <div class="toDate">
                    Please select to date
                  </div>
                }
              </div>

              <div class="col-lg-12 p-0 float-left">
                <div class="col-lg-2 pl-0 p-res-0 float-left">
                  <button type="submit" [disabled]="isSearchDisabled$ | async" class="w-100 mt-1 mt-sm-0 btn btn-primary">
                    {{ 'button.search' | cxTranslate }}
                  </button>
                </div>
                <div class="col-lg-2 pl-0 p-res-0 float-left">
                  <button type="button" (click)="resetForm()" class="w-100 mt-1 mt-sm-0 btn btn-outline-primary">
                    {{ 'button.reset' | cxTranslate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
